import { all, fork } from 'redux-saga/effects';
import retailer from './retailer/saga';
import alerts from './alerts/saga';
import myItems from './myItems/store/sagas';
import user from './user/saga';
import lists from './lists/saga';
import categories from './categories/saga';
import retailers from './retailers/saga';
import retailersGroups from './retailersGroups/saga';
import retailersGroupsTitles from './retailersGroupsTitles/saga';
import notifications from './notifications/saga';
import coupons from './coupons/saga';
import favoriteRetailers from './favoriteRetailers/saga';
import newSales from './newSales/saga';
import onboarding from './onboarding/saga';
import allCoupons from './allCoupons/saga';
import features from './features/saga';
import multiEdit from './multiEdit/saga';
import wallet from './wallet/saga';
import tag from './tag/saga';
import shop from './shop/saga';
import shopCouponCodes from './shopCouponCodes/saga';
import share from './share/saga';
import openPositions from './openPositions/saga';
import landingPage from './landingPage/saga';
import globalSearch from './globalSearch/saga';
import promoMixItems from './promoMixItems/saga';
import promoSearchCoupons from './promoSearchCoupons/saga';
import promoSearchTags from './promoSearchTags/saga';
import promoStoreCoupons from './promoStoreCoupons/saga';
import promoStoreTags from './promoStoreTags/saga';
import karmaEarnList from './karmaEarnList/saga';
import karmaEarnGame from './karmaEarnGame/saga';
import karmaEarnOffer from './karmaEarnOffer/saga';
import giftCards from './giftCards/saga';

export default function* () {
  yield all([
    retailer(),
    alerts(),
    fork(myItems),
    user(),
    lists(),
    categories(),
    retailers(),
    retailersGroups(),
    retailersGroupsTitles(),
    notifications(),
    coupons(),
    favoriteRetailers(),
    newSales(),
    onboarding(),
    allCoupons(),
    features(),
    multiEdit(),
    wallet(),
    tag(),
    shop(),
    shopCouponCodes(),
    share(),
    openPositions(),
    landingPage(),
    globalSearch(),
    promoMixItems(),
    promoSearchCoupons(),
    promoSearchTags(),
    promoStoreCoupons(),
    promoStoreTags(),
    karmaEarnList(),
    karmaEarnGame(),
    karmaEarnOffer(),
    giftCards(),
  ]);
}
